import { createContext } from "react";
import { UserPreferences } from "core/Models";

export const UserPreferencesContext = createContext<UserPreferences>(new UserPreferences());